import React from 'react';

interface SpinnerProps {
  /** Diameter in pixels. */
  size?: number;
  /** Border thickness in pixels. */
  thickness?: number;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 20, thickness = 2 }) => (
  <span
    style={{
      width: size,
      height: size,
      border: `${thickness}px solid color-mix(in srgb, var(--primary-color, #056666) 10%, white)`,
      borderTopColor: 'var(--primary-color, #056666)',
      borderRadius: '50%',
      animation: 'spin 0.8s linear infinite',
      display: 'inline-block',
      flexShrink: 0,
    }}
  />
);

export default Spinner;
